export enum SystemStatuses {
  READY = 'READY',
  UNDER_MAINTENANCE = 'UNDER_MAINTENANCE',
}
